/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  /**
   * Вид для составного фильтра
   */
  app.Filters.CompoundFilterView = app.Filters.SectionFilterView.extend({
    template: '',
    run: function (data) {
      this.template = app.helpers.TemplateHelper.getTemplate('#compound-filter-view');
      if (data.object && data.parent) {
        data.parent.append(
          this.template(data)
        );
        this.setElement($('#' + data.object.name));
      }
    }
  });
})();

}.call(window));